import { Navigate, Route, Routes } from 'react-router-dom';
import { PageTitle } from '../../../_start/layout/core';
import { MediaLibraryPage } from './pages/MediaLibraryPage';
import { SvgLibraryPage } from './pages/SvgLibraryPage';

export const MediaManagementPage = () => {
  return (
    <Routes>
      {/* begin::Routes */}
      <Route
        path="media-library"
        element={
          <>
            <PageTitle>Media Library</PageTitle>
            <MediaLibraryPage />
          </>
        }
      />
      {/* end::Routes */}

      {/* begin::SVG */}
      <Route
        path="svg-library"
        element={
          <>
            <PageTitle>SVG</PageTitle>
            <SvgLibraryPage />
          </>
        }
      />
      {/* end::SVG */}

      <Route
        index
        element={<Navigate to="/media-management/media-libray" replace />}
      />

      <Route
        path="*"
        element={<Navigate to="/media-management/media-libray" replace />}
      />
    </Routes>
  );
};
